export const SUBNSMPS_UPDATE_VALIDATE = 'SUBNSMPS_UPDATE_VALIDATE';
export const SUBNSMPS_CLONE = 'SUBNSMPS_CLONE';
export const SUBNSMPS_DELETE_CLONE = 'SUBNSMPS_DELETE_CLONE';
